/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Preparing_VoInputs */

const en_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing VO Track...`)
};

const fr_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation de la piste VO...`)
};

const de_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO-Track wird vorbereitet...`)
};

const it_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione della traccia VO...`)
};

const ru_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовка аудиодорожки...`)
};

const es_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando pista VO...`)
};

const zh_cn2_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备配音轨道……`)
};

const ja_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VOトラックを準備しています...`)
};

const hi_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वॉयस ओवर ट्रैक तैयार किया जा रहा है...`)
};

const pt_pt2_audio_description_export_status_preparing_vo = /** @type {(inputs: Audio_Description_Export_Status_Preparing_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando a locução...`)
};

/**
* | output |
* | --- |
* | "Preparing VO Track..." |
*
* @param {Audio_Description_Export_Status_Preparing_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_preparing_vo = /** @type {((inputs?: Audio_Description_Export_Status_Preparing_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Preparing_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_preparing_vo(inputs)
	if (locale === "de") return de_audio_description_export_status_preparing_vo(inputs)
	if (locale === "it") return it_audio_description_export_status_preparing_vo(inputs)
	if (locale === "ru") return ru_audio_description_export_status_preparing_vo(inputs)
	if (locale === "es") return es_audio_description_export_status_preparing_vo(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_preparing_vo(inputs)
	if (locale === "ja") return ja_audio_description_export_status_preparing_vo(inputs)
	if (locale === "hi") return hi_audio_description_export_status_preparing_vo(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_preparing_vo(inputs)
	return en_audio_description_export_status_preparing_vo(inputs)
});